import { createFetch } from "../../../../../helpers/fetch/FetchRequest";
import { getCookie } from "../../../../../helpers/common";
import { onAuthError, saveLocationForRedirect } from "../../../../../helpers/data/get/user";
import { API_BUILDER_TOKEN_NODE } from "../../../../../settings/endpoints/stacker";
import { USER_ACCESS_TOKEN_NAME } from "../../../../../settings/global";

export function deleteUserToken({tokenID, remove, onSuccess, onError}) {
    createFetch({
        URL: `${API_BUILDER_TOKEN_NODE}${remove ? '/?id=' + tokenID : ''}`,
        method: remove ? 'DELETE' : 'GET',
        headers: {'Authorization': 'Bearer ' + getCookie(USER_ACCESS_TOKEN_NAME)},
        onSuccess: res => {
            if (onSuccess) onSuccess(res)
        },
        onError: res => {
            if (res.error.status === 401) {
                saveLocationForRedirect();
                onAuthError();
                return;
            }
            if (onError) onError(res)
        },
    })
}